import React from "react"
import ForgotPasswordComponent from "../components/ForgotPasswordComponent"
import LoginSection from "../sections/LoginSection"

//const links = ["signup", "signin"]
const links = ["signin"]

const ForgotPasswordPage = () => {

    return (
        <LoginSection links={links}>
            <ForgotPasswordComponent/>
        </LoginSection>
    )

}

export default ForgotPasswordPage


// WEBPACK FOOTER //
// ./src/auth/pages/ForgotPasswordPage.tsx